import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { INotification, IReport } from '../../../common/sharedTypes';

// types
export enum CorrespondenceActionTypes {
  GET_CORRESPONDENCE = '@@Correspondence_SEARCH',
  CLEAR_CORRESPONDENCE = `@@Correspondence_CLEAR_CORRESPONDENCE`,
}

export const getCorrespondence = (url: string) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.get(url)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceResults = (result: INotification[]) => {
  return {
    type: CorrespondenceActionTypes.GET_CORRESPONDENCE,
    value: result,
  };
};

export const clear = (url: string) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch(reducegetClear());
    resolve();
  });

export const reducegetClear = () => {
  return {
    type: CorrespondenceActionTypes.CLEAR_CORRESPONDENCE,
    value: null,
  };
};
